export const companyTypes = [
  'Corporation',
  'Limited Liability Company (LLC)',
  'Nonprofit Corporation',
  'General Partnership',
  'Limited Partnership',
  'Limited Liability Partnership (LLP)',
  'Professional Limited Liability Partnership (PLLP)',
  'Sole Proprietorship',
  'Joint Venture',
  'Trust',
  'Other Legal Entity Description'
];
